export default {
    pageLength: 'page length',
    of: 'of',

}